import React from "react";
import { useContent } from "../../content/ContentContext";

export const TrustStrip = () => {
  const c = useContent("trust_strip");
  const items = Array.isArray(c.items) ? c.items : [];
  return (
    <section data-testid="trust-strip" className="sc-blush-bg border-y border-blush-200/60">
      <div className="sc-container py-10 md:py-12">
        <ul className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-8">
          {items.map((it, i) => (
            <li key={i} className="text-center md:text-left" data-testid={`trust-item-${i}`}>
              <p className="font-serif text-[1.35rem] md:text-[1.7rem] leading-tight text-ink">
                {it.headline}
              </p>
              <p className="mt-2 text-[13px] md:text-[14px] tracking-wide text-ink2 font-body">
                {it.sub}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default TrustStrip;
